module.exports = __webpack_public_path__ + "static/media/novela.2263b432.png";